import(/* webpackMode: "eager" */ "/home/runner/work/verify.mira.network/verify.mira.network/frontend/src/app/privacy/page.tsx");
